export interface Category {
  slug: string;
  name: string;
  icon: string;
  description: string;
  matchCount: number;
  imageSeq: string;
}

export interface Match {
  id: string;
  league: string;
  homeTeam: string;
  awayTeam: string;
  homeOdds: string;
  drawOdds: string;
  awayOdds: string;
  time: string;
  status: 'live' | 'upcoming' | 'finished';
  score?: string;
  category: string;
}

export interface Article {
  id: string;
  title: string;
  excerpt: string;
  content: string;
  category: string;
  author: string;
  date: string;
  readTime: string;
  imageSeq: string;
  imageUrl: string;
  tags: string[];
}

export interface Promotion {
  id: string;
  title: string;
  description: string;
  badge: string;
  imageSeq: string;
  imageUrl: string;
}

export interface BrandStat {
  label: string;
  value: string;
  icon: string;
}

export const categories: Category[] = [
  {
    slug: 'football',
    name: '足球',
    icon: 'ri-football-line',
    description: '覆盖全球各大联赛，英超、西甲、意甲、德甲、法甲、中超等顶级赛事实时赔率',
    matchCount: 1280,
    imageSeq: 'category-football-01',
  },
  {
    slug: 'basketball',
    name: '篮球',
    icon: 'ri-basketball-line',
    description: 'NBA、CBA、欧洲联赛等顶级篮球赛事全覆盖，实时滚球投注体验',
    matchCount: 860,
    imageSeq: 'category-basketball-01',
  },
  {
    slug: 'tennis',
    name: '网球',
    icon: 'ri-base-station-line',
    description: 'ATP、WTA四大满贯及巡回赛全程覆盖，即时比分与赔率更新',
    matchCount: 540,
    imageSeq: 'category-tennis-01',
  },
  {
    slug: 'esports',
    name: '电竞',
    icon: 'ri-gamepad-line',
    description: 'LOL、DOTA2、CS:GO、王者荣耀等热门电竞项目，专业电竞盘口',
    matchCount: 420,
    imageSeq: 'category-esports-01',
  },
  {
    slug: 'baseball',
    name: '棒球',
    icon: 'ri-boxing-line',
    description: 'MLB、NPB、CPBL等全球棒球联赛，丰富玩法与实时数据',
    matchCount: 320,
    imageSeq: 'category-baseball-01',
  },
  {
    slug: 'others',
    name: '综合',
    icon: 'ri-trophy-line',
    description: '乒乓球、羽毛球、排球、斯诺克、赛车等更多精彩赛事一网打尽',
    matchCount: 680,
    imageSeq: 'category-others-01',
  },
];

export const liveMatches: Match[] = [
  {
    id: 'match-001',
    league: '英超联赛',
    homeTeam: '曼城',
    awayTeam: '阿森纳',
    homeOdds: '1.85',
    drawOdds: '3.60',
    awayOdds: '4.20',
    time: '75\'',
    status: 'live',
    score: '2 : 1',
    category: 'football',
  },
  {
    id: 'match-002',
    league: '西甲联赛',
    homeTeam: '巴塞罗那',
    awayTeam: '皇家马德里',
    homeOdds: '2.10',
    drawOdds: '3.40',
    awayOdds: '3.50',
    time: '62\'',
    status: 'live',
    score: '1 : 1',
    category: 'football',
  },
  {
    id: 'match-003',
    league: 'NBA常规赛',
    homeTeam: '洛杉矶湖人',
    awayTeam: '金州勇士',
    homeOdds: '1.92',
    drawOdds: '-',
    awayOdds: '1.95',
    time: 'Q3 5:42',
    status: 'live',
    score: '78 : 82',
    category: 'basketball',
  },
  {
    id: 'match-004',
    league: '意甲联赛',
    homeTeam: 'AC米兰',
    awayTeam: '尤文图斯',
    homeOdds: '2.45',
    drawOdds: '3.20',
    awayOdds: '2.95',
    time: '38\'',
    status: 'live',
    score: '0 : 0',
    category: 'football',
  },
  {
    id: 'match-005',
    league: 'ATP大师赛',
    homeTeam: '德约科维奇',
    awayTeam: '阿尔卡拉斯',
    homeOdds: '1.72',
    drawOdds: '-',
    awayOdds: '2.15',
    time: 'Set 2',
    status: 'live',
    score: '6:4 3:4',
    category: 'tennis',
  },
  {
    id: 'match-006',
    league: '德甲联赛',
    homeTeam: '拜仁慕尼黑',
    awayTeam: '多特蒙德',
    homeOdds: '1.55',
    drawOdds: '4.20',
    awayOdds: '5.50',
    time: '20:30',
    status: 'upcoming',
    category: 'football',
  },
  {
    id: 'match-007',
    league: 'LPL春季赛',
    homeTeam: 'JDG',
    awayTeam: 'BLG',
    homeOdds: '1.80',
    drawOdds: '-',
    awayOdds: '2.05',
    time: '21:00',
    status: 'upcoming',
    category: 'esports',
  },
  {
    id: 'match-008',
    league: 'MLB常规赛',
    homeTeam: '纽约洋基',
    awayTeam: '波士顿红袜',
    homeOdds: '1.90',
    drawOdds: '-',
    awayOdds: '1.95',
    time: '08:30',
    status: 'upcoming',
    category: 'baseball',
  },
];

export const articles: Article[] = [
  {
    id: 'article-001',
    title: '2026赛季英超联赛前瞻：争冠格局深度分析',
    excerpt: '新赛季英超即将拉开帷幕，曼城、阿森纳、利物浦三强争霸格局是否会被打破？本文从转会市场、战术体系、赛程安排等多维度深度解析。',
    content: `<p>2026赛季英超联赛即将拉开帷幕，各支球队经过夏季转会窗口的调整后，实力格局发生了微妙变化。曼城在瓜迪奥拉的带领下依然保持着强大的统治力，但阿森纳在阿尔特塔的调教下进步神速，利物浦在新帅的带领下也展现出全新的面貌。</p>
<p>从转会市场来看，曼城引进了两名顶级中场球员来弥补德布劳内离队后的空缺，阿森纳则补强了防线和中锋位置，利物浦在前场进行了较大幅度的调整。</p>
<p><strong>争冠热门分析：</strong></p>
<p><strong>曼城（赔率：2.10）</strong> - 作为卫冕冠军，曼城依然是最被看好的球队。哈兰德在锋线上的统治力无可匹敌，中场新援的融入速度将决定球队的上限。</p>
<p><strong>阿森纳（赔率：3.50）</strong> - 连续两个赛季的亚军让枪手积累了宝贵的争冠经验，阵容深度明显提升，萨卡和厄德高的中场组合越发成熟。</p>
<p><strong>利物浦（赔率：5.00）</strong> - 新帅带来了更具侵略性的战术体系，努涅斯和萨拉赫的锋线组合令人期待，但防守端的稳定性仍需检验。</p>
<p>从赛程来看，圣诞新年赛程和欧冠淘汰赛期间的联赛赛程将是决定冠军归属的关键时期。建议关注赛季初的前10轮比赛，这往往能奠定整个赛季的基调。</p>`,
    category: 'football',
    author: '皇冠体育分析师·王磊',
    date: '2026-08-05',
    readTime: '8分钟',
    imageSeq: 'article-001',
    imageUrl: 'https://readdy.ai/api/search-image?query=English%20Premier%20League%20stadium%20with%20dramatic%20floodlights%20and%20golden%20atmosphere%2C%20cinematic%20sports%20photography%20style%2C%20warm%20crimson%20and%20amber%20tones%2C%20abstract%20motion%20feeling%20on%20pitch%2C%20no%20text%20or%20faces&width=800&height=450&seq=article-001-img&orientation=landscape',
    tags: ['英超', '赛季前瞻', '曼城', '阿森纳', '利物浦'],
  },
  {
    id: 'article-002',
    title: 'NBA新赛季东部格局：绿军卫冕之路能否延续',
    excerpt: '凯尔特人上赛季以碾压之势夺冠，新赛季东部各队纷纷补强，雄鹿、76人、热火虎视眈眈，东部格局将如何演变？',
    content: `<p>NBA新赛季即将在10月打响，东部联盟在过去一个休赛期经历了重大变化。卫冕冠军波士顿凯尔特人保留了核心阵容，但其他竞争对手并没有坐以待毙。</p>
<p><strong>东部前四预测：</strong></p>
<p><strong>波士顿凯尔特人（赔率：3.80）</strong> - 塔图姆和布朗的双探花组合正值巅峰，波尔津吉斯健康状态将是卫冕的关键变数。凯尔特人的防守体系依然是联盟顶级。</p>
<p><strong>密尔沃基雄鹿（赔率：5.00）</strong> - 字母哥依然是联盟最具统治力的球员之一，利拉德经过一个赛季的磨合后表现更加稳定。雄鹿的内外线组合令人胆寒。</p>
<p><strong>费城76人（赔率：7.50）</strong> - 恩比德健康时是MVP级别的存在，马克西的成长速度超出预期。76人的阵容深度在东部名列前茅。</p>
<p><strong>迈阿密热火（赔率：11.00）</strong> - 巴特勒在季后赛的爆发力有目共睹，阿德巴约的防守和策应能力使热火始终是东部不可忽视的力量。</p>
<p>值得注意的是，纽约尼克斯和印第安纳步行者的崛起可能会打破传统格局。东部整体竞争水平正在提升，新赛季注定精彩纷呈。</p>`,
    category: 'basketball',
    author: '皇冠体育分析师·陈伟',
    date: '2026-08-03',
    readTime: '7分钟',
    imageSeq: 'article-002',
    imageUrl: 'https://readdy.ai/api/search-image?query=NBA%20basketball%20court%20with%20dramatic%20arena%20lighting%20and%20warm%20golden%20spotlights%2C%20cinematic%20sports%20atmosphere%2C%20crimson%20and%20amber%20color%20palette%2C%20abstract%20court%20action%20motion%2C%20professional%20sports%20photography%20style&width=800&height=450&seq=article-002-img&orientation=landscape',
    tags: ['NBA', '东部格局', '凯尔特人', '雄鹿', '赛季前瞻'],
  },
  {
    id: 'article-003',
    title: '体育博彩入门指南：新手必知的五大投注策略',
    excerpt: '对于刚接触体育博彩的新手玩家，掌握正确的投注策略至关重要。本文整理了五大实用策略，帮助你建立理性的博彩观念。',
    content: `<p>体育博彩作为一项结合了体育知识和概率分析的活动，吸引了越来越多的爱好者。但对于新手来说，如何在享受赛事的同时保持理性投注，是一堂必修课。</p>
<p><strong>策略一：资金管理是基石</strong></p>
<p>永远不要将生活资金用于投注。建议设定每月固定的娱乐预算，单次投注金额不超过总预算的5%。良好的资金管理能让你在长期投注中保持冷静。</p>
<p><strong>策略二：选择熟悉的赛事</strong></p>
<p>专注于你了解和关注的联赛和球队。对赛事背景、球队状态、伤病情况的了解是做出准确判断的基础。不要盲目投注不熟悉的比赛。</p>
<p><strong>策略三：学会分析赔率变化</strong></p>
<p>赔率变化反映了市场对比赛结果的预期调整。关注赛前赔率的波动趋势，结合球队新闻和首发名单，有助于把握最佳投注时机。</p>
<p><strong>策略四：善用数据工具</strong></p>
<p>现代体育博彩离不开数据分析。利用皇冠体育平台提供的实时数据、历史对阵记录、球员状态统计等工具，可以帮助你做出更科学的判断。</p>
<p><strong>策略五：保持长期心态</strong></p>
<p>体育博彩不是一夜暴富的途径。建立长期稳定的收益预期，记录每一笔投注并定期复盘，才能在体育博彩中持续进步。</p>`,
    category: 'guide',
    author: '皇冠体育分析师·刘洋',
    date: '2026-08-01',
    readTime: '6分钟',
    imageSeq: 'article-003',
    imageUrl: 'https://readdy.ai/api/search-image?query=Professional%20sports%20betting%20analysis%20workspace%20with%20warm%20ambient%20lighting%2C%20golden%20and%20crimson%20accents%2C%20clean%20minimal%20desk%20setup%20with%20data%20screens%2C%20premium%20atmosphere%2C%20editorial%20photography%20style&width=800&height=450&seq=article-003-img&orientation=landscape',
    tags: ['投注策略', '新手入门', '博彩指南', '资金管理'],
  },
  {
    id: 'article-004',
    title: '法网决赛回顾：阿尔卡拉斯五盘大战逆转夺冠',
    excerpt: '2026年法网男单决赛精彩绝伦，西班牙天才阿尔卡拉斯在两盘落后的绝境下完成惊天逆转，首次捧起火枪手杯。',
    content: `<p>2026年法国网球公开赛男单决赛在罗兰·加洛斯的菲利普·夏蒂埃球场落下帷幕。赛会2号种子卡洛斯·阿尔卡拉斯在0-2落后的绝境中连扳三盘，以3-6、4-6、7-5、6-3、6-2的比分逆转击败世界第一扬尼克·辛纳，职业生涯首次夺得法网冠军。</p>
<p><strong>比赛回顾：</strong></p>
<p>前两盘比赛中，辛纳的发球和底线进攻火力全开，几乎不给阿尔卡拉斯任何机会。意大利人凭借精准的落点控制和出色的移动，以6-3和6-4顺利拿下前两盘。</p>
<p>第三盘成为比赛的转折点。阿尔卡拉斯在3-5落后的发球局中连救两个赛点，随后提升状态连赢四局，以7-5惊险扳回一盘。</p>
<p>此后，阿尔卡拉斯的体能优势开始显现。第四盘他在底线对攻中完全占据上风，以6-3将大比分扳平。决胜盘中，辛纳体能明显下降，阿尔卡拉斯抓住机会以6-2锁定胜局。</p>
<p>这场耗时4小时28分钟的经典对决，不仅展现了两位新生代球员的超强实力，也为网坛未来的格局写下了浓墨重彩的一笔。</p>`,
    category: 'tennis',
    author: '皇冠体育分析师·张明',
    date: '2026-07-28',
    readTime: '5分钟',
    imageSeq: 'article-004',
    imageUrl: 'https://readdy.ai/api/search-image?query=French%20Open%20tennis%20clay%20court%20with%20warm%20sunset%20lighting%20and%20golden%20atmosphere%2C%20dramatic%20cinematic%20sports%20style%2C%20crimson%20and%20amber%20tones%2C%20abstract%20motion%20on%20court%2C%20no%20text%20or%20faces&width=800&height=450&seq=article-004-img&orientation=landscape',
    tags: ['法网', '阿尔卡拉斯', '网球', '大满贯', '决赛'],
  },
  {
    id: 'article-005',
    title: '电子竞技投注指南：LOL全球总决赛夺冠热门分析',
    excerpt: '英雄联盟全球总决赛即将开打，LCK与LPL双雄争霸格局下，谁最有可能问鼎召唤师杯？深度解析各战队实力与赔率。',
    content: `<p>作为电子竞技领域最具影响力的赛事，英雄联盟全球总决赛每年都吸引着全球数亿观众的关注。2026赛季的全球总决赛即将拉开帷幕，各赛区的顶级战队已经蓄势待发。</p>
<p><strong>夺冠赔率TOP5：</strong></p>
<p><strong>Gen.G（LCK）- 赔率：3.25</strong> - LCK夏季赛冠军，中野配合默契度极高，Chovy的个人能力在关键时刻总能站出来。整体战术执行力在所有参赛队伍中首屈一指。</p>
<p><strong>BLG（LPL）- 赔率：4.00</strong> - LPL夏季赛表现最为稳定的队伍，knight和Bin的双核驱动火力十足。BLG的国际赛经验丰富，是LPL最具冠军相的队伍。</p>
<p><strong>T1（LCK）- 赔率：5.50</strong> - Faker领衔的T1永远是全球总决赛不可忽视的力量。虽然常规赛表现起伏，但T1的大赛经验无人能及。</p>
<p><strong>JDG（LPL）- 赔率：6.00</strong> - 拥有Kanavi和Ruler的JDG依旧是LPL的顶级强队，只要找到版本节奏，JDG有实力击败任何对手。</p>
<p><strong>G2（LEC）- 赔率：13.00</strong> - 欧洲之王G2在本赛季展现了极强的创造力，Caps的状态回暖让G2重新成为世界级强队。</p>
<p>版本理解和临场适应能力将是本届全球总决赛的关键变量。建议关注小组赛阶段各队的BP策略和战术选择。</p>`,
    category: 'esports',
    author: '皇冠体育分析师·李浩',
    date: '2026-07-25',
    readTime: '7分钟',
    imageSeq: 'article-005',
    imageUrl: 'https://readdy.ai/api/search-image?query=Esports%20gaming%20arena%20with%20dramatic%20stage%20lighting%20and%20warm%20golden%20spotlights%2C%20cinematic%20gaming%20atmosphere%2C%20crimson%20and%20amber%20energy%2C%20abstract%20competitive%20gaming%20scene%2C%20professional%20photography%20style&width=800&height=450&seq=article-005-img&orientation=landscape',
    tags: ['电竞', '英雄联盟', '全球总决赛', 'LOL', 'Gen.G'],
  },
  {
    id: 'article-006',
    title: '滚球投注技巧：如何在比赛中把握最佳时机',
    excerpt: '滚球投注（Live Betting）为玩家提供了在比赛进行中下注的机会。掌握滚球投注的核心技巧，能让你在瞬息万变的赛场上发现价值。',
    content: `<p>滚球投注（也称为现场投注或走地盘）是体育博彩中最具魅力的玩法之一。与赛前投注不同，滚球投注允许玩家在比赛进行中根据实时情况调整投注策略。</p>
<p><strong>滚球投注的核心优势：</strong></p>
<p>第一，信息优势。赛前投注只能依靠历史数据和预测，而滚球投注可以观察比赛的实际进程。球队的状态、战术安排、球员的临场发挥一目了然。</p>
<p>第二，赔率动态变化。随着比赛进程的推进，赔率会实时调整。敏锐的玩家可以在赔率波动中发现价值投注机会。</p>
<p><strong>实用技巧分享：</strong></p>
<p><strong>关注比赛节奏变化</strong> - 足球比赛中，一支球队在落后时往往会加强进攻，这可能导致后防线出现漏洞。篮球比赛中，替补阵容上场时节奏可能发生明显变化。</p>
<p><strong>利用统计数据</strong> - 皇冠体育提供实时数据统计，包括控球率、射门次数、角球数等。这些数据能帮助你判断比赛的走势。</p>
<p><strong>设定止损点</strong> - 滚球投注节奏快，容易让人上头。务必在投注前设定单场和单日的止损金额。</p>
<p><strong>关注关键事件</strong> - 红牌、点球、关键球员受伤等事件会瞬间改变比赛走向，赔率也会因此剧烈波动。</p>`,
    category: 'guide',
    author: '皇冠体育分析师·王磊',
    date: '2026-07-20',
    readTime: '6分钟',
    imageSeq: 'article-006',
    imageUrl: 'https://readdy.ai/api/search-image?query=Dynamic%20live%20sports%20match%20atmosphere%20with%20real%20time%20data%20visualization%20concept%2C%20warm%20golden%20and%20crimson%20lighting%2C%20abstract%20motion%20and%20energy%20particles%2C%20premium%20sports%20analytics%20style%2C%20cinematic%20composition&width=800&height=450&seq=article-006-img&orientation=landscape',
    tags: ['滚球投注', '技巧分享', 'Live Betting', '投注策略'],
  },
];

export const promotions: Promotion[] = [
  {
    id: 'promo-001',
    title: '新用户注册首存礼金',
    description: '新用户完成注册并首次存款，即可获得100%存款匹配奖金，最高可领取888元投注礼金，助您开启体育博彩之旅。',
    badge: '限时优惠',
    imageSeq: 'promo-welcome',
    imageUrl: 'https://readdy.ai/api/search-image?query=Luxurious%20golden%20welcome%20bonus%20concept%20with%20warm%20crimson%20and%20gold%20abstract%20background%2C%20premium%20celebration%20atmosphere%2C%20soft%20particle%20effects%2C%20elegant%20glowing%20accents%2C%20dark%20moody%20background%20with%20golden%20light&width=800&height=400&seq=promo-welcome-img&orientation=landscape',
  },
  {
    id: 'promo-002',
    title: '体育赛事连赢加奖',
    description: '参与足球、篮球等热门赛事连赢投注，最高可享受30%额外奖金加成。连赢场次越多，奖金加成越高。',
    badge: '热门活动',
    imageSeq: 'promo-streak',
    imageUrl: 'https://readdy.ai/api/search-image?query=Winning%20streak%20concept%20with%20golden%20trophy%20and%20warm%20crimson%20abstract%20background%2C%20premium%20sports%20victory%20atmosphere%2C%20soft%20glowing%20particles%2C%20elegant%20dark%20background%20with%20amber%20highlights&width=800&height=400&seq=promo-streak-img&orientation=landscape',
  },
  {
    id: 'promo-003',
    title: 'VIP尊享专属返水',
    description: '皇冠体育VIP会员每笔有效投注均可享受最高1.2%即时返水，大额投注更可申请专属赔率提升服务。',
    badge: 'VIP专享',
    imageSeq: 'promo-vip',
    imageUrl: 'https://readdy.ai/api/search-image?query=Exclusive%20VIP%20membership%20concept%20with%20golden%20crown%20and%20crimson%20abstract%20background%2C%20premium%20luxury%20atmosphere%2C%20soft%20sparkle%20effects%2C%20dark%20elegant%20background%20with%20golden%20accents&width=800&height=400&seq=promo-vip-img&orientation=landscape',
  },
];

export const brandStats: BrandStat[] = [
  { label: '运营年限', value: '15+', icon: 'ri-calendar-check-line' },
  { label: '注册用户', value: '500万+', icon: 'ri-user-star-line' },
  { label: '月均赛事', value: '10,000+', icon: 'ri-trophy-line' },
  { label: '合作机构', value: '50+', icon: 'ri-team-line' },
];

export const faqItems = [
  {
    question: '如何注册皇冠体育账号？',
    answer: '注册皇冠体育账号非常简单。点击页面右上角的"立即注册"按钮，填写手机号码或邮箱地址，设置登录密码，完成短信或邮箱验证后即可成功注册。整个过程仅需1-2分钟。',
  },
  {
    question: '皇冠体育支持哪些存款方式？',
    answer: '皇冠体育支持多种安全便捷的存款方式，包括银行转账、支付宝、微信支付、USDT数字货币等。所有存款均享受实时到账服务，且不收取任何手续费。',
  },
  {
    question: '提款需要多长时间到账？',
    answer: '皇冠体育承诺快速提款服务。一般情况下，提款申请提交后5-30分钟内即可到账。大额提款可能需要额外的安全审核，但通常不会超过2小时。我们支持24小时全天候提款服务。',
  },
  {
    question: '皇冠体育的赔率水平如何？',
    answer: '皇冠体育采用国际领先的赔率体系，在足球、篮球等主流赛事中提供极具竞争力的赔率。我们的赔率团队由资深数据分析师组成，确保赔率既能反映真实概率，又为玩家提供充足的投注价值。',
  },
  {
    question: '手机端可以投注吗？',
    answer: '当然可以！皇冠体育提供专业的移动端投注体验。您可以通过手机浏览器直接访问皇冠体育官网，也可以下载皇冠体育手机APP，享受更流畅的移动投注服务。移动端功能与电脑端完全同步，随时随地畅享体育博彩。',
  },
  {
    question: '皇冠体育是合法平台吗？',
    answer: '皇冠体育持有合法的博彩运营牌照，严格遵守国际博彩行业规范。我们采用SSL加密技术和严格的资金隔离制度，确保用户信息和资金安全。平台运营15年以上，服务超过500万用户，信誉有保障。',
  },
];